// import { SentimentSatisfiedAltSharp } from "@material-ui/icons";
import AWS from "aws-sdk/index";
import { AWS_API } from "lib/apiSecret";
import { APP_NAME } from "lib/global";
import "filepond/dist/filepond.min.css";
import { formatArray } from "lib/arrayObject";
import { jsonParse } from "lib/json";
import { downloadURI } from "lib/request";
import { isEmpty } from "lodash";
import React, { memo, useMemo, useState } from "react";
import { FilePond } from "react-filepond";

const s3 = new AWS.S3({
  accessKeyId: AWS_API.AWS_ACCESS_KEY_ID,
  secretAccessKey: AWS_API.AWS_SECRET_ACCESS_KEY,
  region: AWS_API.AWS_DEFAULT_REGION,
});

export default memo(function S3MultiFileUpload({
  files,
  onChange = () => {},
  className = "",
  ...props
}) {
  // files must be json type
  // required props
  // files, onChange, title, description, browseName, allowMultiple, allowImagePreview, destination

  onChange = typeof onChange === "function" ? onChange : () => {};
  const jsonFilesList = JSON.stringify(files);
  const fileList = formatArray(files).map((item) => {
    return {
      // the server file reference
      source: String(item).indexOf("https://") >= 0 ? item : `/${item}`,

      // set type to limbo to tell FilePond this is a temp file
      options: {
        type: "limbo",
        // type: 'local',
        // type: 'input',
      },
    };
  });

  const [uuid] = useState(`${Math.random()}`);

  const uploadPreparedCount = (v) =>
    v
      ? window.sessionStorage.setItem("uploadPreparedCount", JSON.stringify(v))
      : jsonParse(window.sessionStorage.getItem("uploadPreparedCount"));

  const uploadDoneCount = (v) =>
    v
      ? window.sessionStorage.setItem("uploadDoneCount", JSON.stringify(v))
      : jsonParse(window.sessionStorage.getItem("uploadDoneCount"));

  const uploadDoneFiles = (v) =>
    v
      ? window.sessionStorage.setItem("uploadDoneFiles", JSON.stringify(v))
      : jsonParse(window.sessionStorage.getItem("uploadDoneFiles"));

  return (
    <div
      className={`multi-file-upload ${className}`}
      style={props?.style ?? {}}
    >
      {Boolean(props?.title) && <h3>{props?.title ?? "Upload your files"}</h3>}
      {Boolean(props?.description) && (
        <p>
          {props?.description ??
            "You can upload images(*.jpg, *.png, *.gif, *.tiff, etc) and documents(*.doc, *.docx, *.pdf, etc)."}
        </p>
      )}
      {useMemo(
        () => (
          <FilePond
            disabled={Boolean(props?.disabled)}
            files={fileList}
            name="file"
            labelIdle={
              props?.browseName ??
              'Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
            }
            allowMultiple={props?.allowMultiple ?? false}
            allowImagePreview={props?.allowImagePreview ?? false}
            maxFiles={10}
            maxParallelUploads={10}
            allowFileSizeValidation={false}
            onpreparefile={() => {
              if (isEmpty(uploadPreparedCount())) {
                uploadPreparedCount({});
              }
              uploadPreparedCount({
                ...uploadPreparedCount(),
                [uuid]: (uploadPreparedCount()?.[uuid] ?? 0) + 1,
              });
            }}
            server={{
              process: function (
                fieldName,
                file,
                metadata,
                load,
                error,
                progress,
                abort
              ) {
                s3.upload(
                  {
                    Bucket:
                      AWS_API.AWS_BUCKET_NAME +
                      "/" +
                      APP_NAME +
                      "/" +
                      (props?.destination || "other") +
                      "/" +
                      uuid,
                    Key: String(file.name ?? "").replace(/[^.\w]/g, "_"),
                    Body: file,
                    ContentType: file.type,
                    ACL: "public-read",
                  },
                  function (err, data) {
                    if (err) {
                      error("Something went wrong");
                      return;
                    }

                    // pass file unique id back to filepond
                    load(data.Key);
                    const path = data?.Location ?? "";

                    // save count
                    if (isEmpty(uploadDoneCount())) {
                      uploadDoneCount({});
                    }
                    uploadDoneCount({
                      ...uploadDoneCount(),
                      [uuid]: (uploadDoneCount()?.[uuid] ?? 0) + 1,
                    });

                    // save file
                    if (isEmpty(uploadDoneFiles())) {
                      uploadDoneFiles({});
                    }
                    uploadDoneFiles({
                      ...uploadDoneFiles(),
                      [uuid]: [
                        ...formatArray(uploadDoneFiles()?.[uuid]),
                        String(path),
                      ],
                    });

                    // all done?
                    if (
                      uploadPreparedCount()?.[uuid] ===
                        uploadDoneCount()?.[uuid] &&
                      Boolean(uploadDoneCount()?.[uuid] > 0)
                    ) {
                      uploadPreparedCount({
                        ...uploadPreparedCount(),
                        [uuid]: 0,
                      });
                      uploadDoneCount({ ...uploadDoneCount(), [uuid]: 0 });

                      if (typeof onChange === "function") {
                        console.log(
                          [
                            ...(files ?? []),
                            ...(uploadDoneFiles()?.[uuid] ?? []),
                          ].filter((item, index, self) =>
                            Boolean(self.indexOf(item) === index)
                          )
                        );
                        onChange(
                          [
                            ...(files ?? []),
                            ...(uploadDoneFiles()?.[uuid] ?? []),
                          ].filter((item, index, self) =>
                            Boolean(self.indexOf(item) === index)
                          )
                        );
                      }
                    }
                  }
                );
              },
              // restore: (uniqueFileId, load, error) => {
              //   fetch(uniqueFileId)
              //     .then((res) => res.blob())
              //     .then(load)
              //     .catch(error)
              // },
              revert: (fileId, callback, error) => {
                // console.log(fileId)
                // s3.deleteBucket(
                //   {
                //     Bucket: AWS_API.AWS_BUCKET_NAME + '/' + fileId,
                //   },
                //   (err, data) => {
                //     if (err) error('Something went wrong.')
                //     callback()
                //   },
                // )
              },

              onerror: null,
              ondata: null,
            }}
            onremovefile={(err, file) => {
              if (!err) {
                const path = file?.serverId;
                const matchIndex = files.findIndex(
                  (item) =>
                    (String(item).indexOf("https://") >= 0
                      ? item
                      : `/${item}`) === path
                );

                if (matchIndex >= 0) {
                  console.log("deleted ==>");
                  onChange([
                    ...formatArray(files).slice(0, matchIndex),
                    ...formatArray(files).slice(matchIndex + 1),
                  ]);
                }
              }
            }}
            // download
            onactivatefile={(file) => downloadURI(file?.source)}
            labelFileProcessingComplete="Click to Download"
            acceptedFileTypes={[
              "image/*",
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              "application/pdf",
              "video/*",
            ]}
          />
        ),
        // eslint-disable-next-line
        [jsonFilesList]
      )}
    </div>
  );
});
